<script lang="ts">
    import KpPopoverPanel from 'shared/ui-widgets/popover/KpPopoverPanel.svelte';
    import KpStaticSearchResults from 'src/features/search/kp-search-results/KpStaticSearchResults.svelte';
    import SelectableItemsContainer from 'src/modals/search-selection-modal/SelectableItemsContainer.svelte';
    import KpSelectableRecordCard from 'shared/value-editors/internal/editors/search-or-edit/templates/KpSelectableRecordCard.svelte';
    import type {SearchManager} from 'src/features/search/search-manager/search-manager';
    import type {Rec, RecordSearchParams} from 'typings/portaro.be.types';
    import type {ActionArray} from 'shared/utils/svelte-actions-utils';
    import {tick} from 'svelte';
    import {exists} from 'shared/utils/custom-utils';

    export let searchManager: SearchManager<Rec, RecordSearchParams>;
    export let open = false;
    export let use: ActionArray = [];
    export let onSelect: (item: Rec) => void;

    $: itemIsSelected = exists(selectedItem);
    $: isSubmittable = itemIsSelected;

    let selectedItem: Rec | null = null;

    async function select(item: Rec) {
        selectedItem = item;
        await tick(); // wait for update of reactive values denpended on 'selectedItem`
        submitSelectedItem();
    }

    function submitSelectedItem() {
        if (isSubmittable) {
            onSelect(selectedItem);
        }
    }

</script>


<KpPopoverPanel popoverMode="manual" additionalClasses="record-search-popover" {use} bind:open let:togglePopover>
    <KpStaticSearchResults pagination="{searchManager.getPagination()}" loadingSize="sm" let:paginationData>
        <SelectableItemsContainer items="{paginationData.items}"
                                  on:select={(event) => {select(event.detail); togglePopover();}}
                                  let:item>
            <KpSelectableRecordCard value="{item}" isSelected="{item === selectedItem}"/>
        </SelectableItemsContainer>
    </KpStaticSearchResults>
</KpPopoverPanel>

<style lang="less">
    @import (reference) "bootstrap-less/bootstrap/variables";

    :global {
        .record-search-popover {
            .content {
                overflow-y: auto;
                width: auto;
                max-height: 50dvh;

                @media (min-width: @screen-sm-min) {
                    width: 600px;
                }
            }

        }
    }
</style>